<template>
  <div class="no-select" v-if="Array.isArray(leilao.status)">
    <div class="flex items-center m-b-xs" v-for="(s, i) in leilao.status">
      <span class="m-r-xs font-bold">#{{i+1}}</span> <status-leilao-selector :status="s.status" />
    </div>
  </div>
  <status-leilao-selector class="no-select" v-else :status="leilao.status" />
</template>

<script>
import StatusLeilaoSelector from './StatusLeilaoSelector'
export default {
  name: 'StatusLeilao',
  components: {StatusLeilaoSelector},
  props: ['leilao']
}
</script>

<style scoped>

</style>
